export const rootStyles = {
  fontWeight: 700,
};

export const selectorsListStyles = theme => ({
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  height: '100%',
  overflowY: 'scroll',
  padding: `0 0 ${theme.spacing(4.5)}`,
  scrollbarWidth: 'none',
});
